var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLearn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005C99",
    fillRule: "nonzero",
    d: "M23.98.363H7.746a2.663 2.663 0 0 0-2.66 2.66V22.59a2.664 2.664 0 0 0 2.658 2.661h.892v3.739a.647.647 0 0 0 1.122.442l1.148-1.226 1.148 1.226a.648.648 0 0 0 1.122-.443V25.25h10.802a.648.648 0 0 0 .649-.649V1.011a.648.648 0 0 0-.649-.648ZM8.394 1.659h14.936v18.272H8.395V1.66Zm-1.297.164v18.19a2.659 2.659 0 0 0-.715.298V3.022c0-.517.291-.968.715-1.199Zm.65 22.131a1.366 1.366 0 0 1-1.365-1.364c0-.752.612-1.364 1.364-1.364H23.33v.716H7.756a.648.648 0 1 0 0 1.297h.882v.715h-.89Zm4.131 3.394-.499-.533a.647.647 0 0 0-.947 0l-.5.533v-4.11h1.946v4.11Zm1.297-4.109H23.33v.715H13.176v-.715Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLearn);
export default ForwardRef;